var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content container p-0"},[(_vm.error)?_c('error-page',{attrs:{"error":_vm.error,"status-code":_vm.statusCode}}):_c('page-loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }